import { belongsTo, } from '@tencent/exeditor3-core';
import '@tencent/exeditor3-ui-kit/dist/toolbar-select.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import { defaultOption } from './data.js';
const NAME = 'textIndent';
const getTextIndent = (pos) => {
    // 段首且缩进
    if (pos.parentOffset !== 0) {
        return undefined;
    }
    const node = pos.node();
    const value = node.attrs[NAME];
    if (!value) {
        return undefined;
    }
    return value;
};
export class TextIndentPlugin {
    constructor(opt) {
        this.name = NAME;
        this.set = (v) => {
            this.editor.selection(true).updateNodeAttr(this.opt.target, this.name, v);
        };
        this.get = () => this.editor.selection().getNodeAttr(this.opt.target, this.name);
        this.canApply = () => this.editor.selection().hasNode(this.opt.target);
        this.handleModBackspace = () => {
            const { empty, $from } = this.editor.selection();
            const value = getTextIndent($from);
            if (!empty || !value) {
                return false;
            }
            const nextValue = this.findNextValue(value, 'decrease');
            if (nextValue === null) {
                return false;
            }
            this.set(''); // 删除所有缩进
            return true;
        };
        this.handleBackspace = () => {
            const { empty, $from } = this.editor.selection();
            const value = getTextIndent($from);
            if (!empty || !value) {
                return false;
            }
            const nextValue = this.findNextValue(value, 'decrease');
            if (nextValue === null) {
                return false;
            }
            this.set(nextValue);
            return true;
        };
        this.increaseIndent = (state, _dispatch, view) => {
            if (!this.isAtTargetStart(state, view)) {
                return false;
            }
            const indent = this.findNextValue(this.get() || '', 'increase');
            if (indent !== null)
                this.set(indent);
            return true;
        };
        this.decreaseIndent = (state, _dispatch, view) => {
            if (!this.isAtTargetStart(state, view)) {
                return false;
            }
            const indent = this.findNextValue(this.get() || '', 'decrease');
            if (indent !== null)
                this.set(indent);
            return true;
        };
        this.findNextValue = (value, incOrDec) => {
            var _a;
            const foundIndex = (_a = this.opt.options) === null || _a === void 0 ? void 0 : _a.findIndex((entry) => entry.value === value);
            if (foundIndex === -1) {
                return '';
            }
            const index = incOrDec === 'increase' ? foundIndex + 1 : foundIndex - 1;
            const nextOption = this.opt.options[index];
            if (!nextOption) {
                return null;
            }
            return nextOption.value;
        };
        this.opt = {
            ...defaultOption,
            ...opt,
        };
        this.specExtraAttrs = {
            textIndent: {
                target: this.opt.target,
                parse: (elt) => elt.style.textIndent,
                toDOMAttribute: (textIndent) => ({
                    style: textIndent ? `text-indent: ${textIndent}` : '',
                }),
            },
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                set: this.set,
                get: this.get,
            },
            shortcuts: {
                Tab: this.increaseIndent,
                'Shift-Tab': this.decreaseIndent,
                Backspace: this.handleBackspace,
                'Mod-Backspace': this.handleModBackspace,
            },
        };
    }
    renderToolbarItem() {
        const select = document.createElement('exeditor-toolbar-select');
        select.label = this.editor.t('首行缩进');
        const icon = createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.textIndentIcon),
        });
        select.appendChild(icon);
        this.opt.options.forEach((entry) => {
            const option = document.createElement('exeditor-toolbar-option');
            option.slot = 'option';
            option.value = entry.value;
            option.innerText = this.editor.t(entry.label);
            option.onclick = () => {
                this.editor.focus();
                this.set(entry.value);
            };
            select.appendChild(option);
        });
        const setBtnProps = () => {
            const indent = this.get();
            select.active = Boolean(indent);
            select.value = indent || '';
            select.disabled = !this.canApply();
        };
        setBtnProps();
        this.editor.on('idlechange', setBtnProps);
        return select;
    }
    isAtTargetStart(state, view) {
        if (!state.selection.empty) {
            return false;
        }
        const node = state.selection.$from.parent;
        if (!node || !belongsTo(node, this.opt.target)) {
            return false;
        }
        if (view === null || view === void 0 ? void 0 : view.endOfTextblock('backward', state)) {
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=index.js.map